import { Typography } from "@lyfegen-platform/react-common";
import { Box } from "@material-ui/core";
import useMessagesStyles from "../use-messages-styles";
import Linkify from "react-linkify";

const formatMessageContent = (v: string) => {
	const { contentMessage } = useMessagesStyles();
	const nameRegexp = /@([A-z]+[ ]?([A-z]+)?)/g;
	if (nameRegexp.test(v)) {
		const newA = v.replaceAll(nameRegexp, (v) => v.replace(" ", "_"));
		return (
			<Box display="inline">
				{newA.split(" ").map((t, i) => {
					if (t.match(nameRegexp)) {
						return (
							<Typography className={contentMessage} key={i} display="inline" color="primary">{`${t.replace(
								"_",
								" "
							)} `}</Typography>
						);
					}
					return <Typography className={contentMessage} key={i} display="inline">{`${t} `}</Typography>;
				})}
			</Box>
		);
	}
	return (
		<Typography className={contentMessage}>
			<Linkify>{v}</Linkify>
		</Typography>
	);
};

export default formatMessageContent;
